/**
 * SLA API Client (PROJ-007)
 * API functions for SLA timer management
 */

import { apiRequest } from './standard-api';
import type { SlaTimer, SlaStats, SlaWarning } from '../types/sla';

/**
 * List SLA timers for an incident
 */
export async function listSlaTimers(incidentId: string): Promise<SlaTimer[]> {
  const response = await apiRequest<SlaTimer[]>(
    `/api/v1/incidents/${incidentId}/sla`
  );
  return response.data;
}

/**
 * Get SLA statistics for an incident
 */
export async function getSlaStats(incidentId: string): Promise<SlaStats> {
  const response = await apiRequest<SlaStats>(
    `/api/v1/incidents/${incidentId}/sla/stats`
  );
  return response.data;
}

/**
 * Get SLA warnings across all incidents
 * @param hoursThreshold - Hours threshold for warnings (default: 2)
 */
export async function getSlaWarnings(hoursThreshold: number = 2): Promise<SlaWarning[]> {
  const response = await apiRequest<SlaWarning[]>(
    `/api/v1/sla/warnings?hours=${hoursThreshold}`
  );
  return response.data;
}

/**
 * Manually trigger SLA breach check
 * (Normally run by cron job)
 */
export async function triggerBreachCheck(): Promise<{
  checked: number;
  breached: number;
  errors?: Array<{ timerId: string; error: string }>;
}> {
  const response = await apiRequest<{
    checked: number;
    breached: number;
    errors?: Array<{ timerId: string; error: string }>;
  }>('/api/v1/sla/check-breaches', {
    method: 'POST'
  });
  return response.data;
}

export default {
  listSlaTimers,
  getSlaStats,
  getSlaWarnings,
  triggerBreachCheck
};
